import { render, staticRenderFns } from "./RolePageView.vue?vue&type=template&id=33508d55&scoped=true"
import script from "./RolePageView.vue?vue&type=script&lang=js"
export * from "./RolePageView.vue?vue&type=script&lang=js"
import style0 from "./RolePageView.vue?vue&type=style&index=0&id=33508d55&prod&scoped=true&lang=css"
import style1 from "./RolePageView.vue?vue&type=style&index=1&id=33508d55&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33508d55",
  null
  
)

export default component.exports